import { getCredentialsHeaders } from "@/app-utils/credentials.ts";
import { urls } from "@/modules/app/utils/urls.ts";
import { notify } from "@/modules/notifications/notify.tsx";
import { ENTITY_TYPE } from "@/settings/settings.ts";

/**
 * Calls the endpoint to create a sequence analyzer session
 * @param selectedIds GES IDs
 * @param innerEntityType FeatureType
 */
export const createSequenceAnalyzerSession = async (selectedIds?: number[], innerEntityType?: string) => {
  const response = await fetch(`${urls.api}/sequenceAnalyzer/createSession`, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json", ...getCredentialsHeaders() },
    body: JSON.stringify({
      sequenceIds: selectedIds,
      featureType: innerEntityType,
    }),
    cache: "no-cache",
  });

  if (!response.ok) {
    const err = await response.text();
    notify.error({ title: "Sequence Analyzer", children: err }, { autoClose: 5000 });
  } else {
    const data = await response.text();
    if (data) {
      return data;
    }
  }

  return null;
};

/**
 * Calls the validation endpoint to verify all selected entities have residues.
 * @param selectedIds GES IDs
 * @param innerEntityType FeatureType
 */
export const validateSequences = async (selectedIds?: number[], innerEntityType?: string): Promise<string[]> => {
  const response = await fetch(`${urls.api}/sequenceAnalyzer/validateSequences`, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json", ...getCredentialsHeaders() },
    body: JSON.stringify({
      sequenceIds: selectedIds,
      featureType: innerEntityType,
    }),
    cache: "no-cache",
  });

  if (!response.ok) {
    const err = await response.text();
    notify.error({ title: "Sequence Analyzer", children: err }, { autoClose: 5000 });
  } else {
    const data = await response.json();
    if (data) {
      return data.payload;
    }
  }

  return [];
};

export enum WEB_ANALYZER_KEYS {
  SEQUENCE_ANALYZER = "sequence-analyzer",
}

// May become a flat list, keep grouping for now
export const sequenceViewerSupportedTypes = {
  gene: [ENTITY_TYPE.GENE, ENTITY_TYPE.TRANSCRIPT, ENTITY_TYPE.TRANSCRIPT_LOCATION],
  protein: [ENTITY_TYPE.PROTEIN, ENTITY_TYPE.PROTEIN_LOCATION],
};
